import { render, staticRenderFns } from "./OneEuEnergyLabel.vue?vue&type=template&id=5be212ea&scoped=true&"
import script from "./OneEuEnergyLabel.vue?vue&type=script&lang=ts&"
export * from "./OneEuEnergyLabel.vue?vue&type=script&lang=ts&"
import style0 from "./OneEuEnergyLabel.vue?vue&type=style&index=0&id=5be212ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.8_css-loader@4.3.0_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be212ea",
  null
  
)

export default component.exports